<template>
    <div>
        <v-row justify="center" style="background-color: #06599D;">
            <v-col cols="0" sm="2"></v-col>
            <v-col cols="12" sm="8">
                <v-row>
                    <v-container>
                        <div class="text-white">
                            <h1 class="general-heading">
                                <LanguagePlaceholder is-html
                                    default-text="​​​​​​Distributor RISE Marketing Assets" />
                            </h1>
                            <p class="general-heading">
                                <LanguagePlaceholder is-html
                                    default-text="​​​​​Incentive Period: 3 May 2025 – 1 August 2025" />

                            </p>
                            <p>
                                <LanguagePlaceholder default-text="A comprehensive range of marketing assets is available for you to promote the RISE Incentive program to your partners." />
                            </p>
                            <br>
                            <p>
                                <LanguagePlaceholder default-text="Using these marketing assets to support your partners through their RISE Incentive Program journey will encourage them to increase their purchase volumes, which will grow their profitability as well as yours." />
                            </p>
                            <br>
                            <p>
                                <LanguagePlaceholder default-text="The marketing assets are shown by user journey stage." />
                            </p>
                        </div>

                    </v-container>

                </v-row>
            </v-col>
            <v-col cols="0" sm="2"></v-col>
        </v-row>
        <v-row justify="center" style="background-color: #ffffff;">
            <v-col cols="0" sm="2"></v-col>
            <v-col cols="12" sm="8">
                <v-row>
                    <v-container>
                        <v-row>
                            <div class="text-black">
                                <p class="general-heading">
                                    <LanguagePlaceholder is-html
                                        default-text="Website Assets Pack" />
                                </p>
                                <br>
                                <p class="genral-text">
                                    <LanguagePlaceholder is-html
                                        default-text="In this pack you will find everything you need to create a webpage highlighting the benefits of the RISE Incentive Program." />
                                </p>
                            </div>
                        </v-row>
                        <v-row justify="center">
                            <v-col cols="12" md="3">
                                <MarketingAssetsFileButton button-text="English" file-name="WEBSITE ASSET PACK/Website Asset pack EN.zip"
                                    container="files" color="#e5f6ff" text-color="#055699" >
                                    <LanguagePlaceholder default-text="English" />
                                </MarketingAssetsFileButton>
                            </v-col>
                            <v-col cols="12" md="3">
                                <MarketingAssetsFileButton button-text="French" file-name="WEBSITE ASSET PACK/Website Asset pack FR.zip"
                                    container="files" color="#e5f6ff" text-color="#055699" />
                            </v-col>
                            <v-col cols="12" md="3">
                                <MarketingAssetsFileButton button-text="German" file-name="WEBSITE ASSET PACK/Website Asset pack DE.zip"
                                    container="files" color="#e5f6ff" text-color="#055699" />
                            </v-col>
                            <v-col cols="12" md="3">
                                <MarketingAssetsFileButton button-text="Italian" file-name="WEBSITE ASSET PACK/Website Asset pack IT.zip"
                                    container="files" color="#e5f6ff" text-color="#055699" />
                            </v-col>
                        </v-row>
                        <v-row justify="center">
                            <v-col cols="12" md="3">
                                <MarketingAssetsFileButton button-text="Polish" file-name="WEBSITE ASSET PACK/Website Asset pack PL.zip"
                                    container="files" color="#e5f6ff" text-color="#055699" />
                            </v-col>
                            <v-col cols="12" md="3">
                                <MarketingAssetsFileButton button-text="Spanish" file-name="WEBSITE ASSET PACK/Website Asset pack ES.zip"
                                    container="files" color="#e5f6ff" text-color="#055699" />
                            </v-col>
                            <v-col cols="12" md="3">
                                <MarketingAssetsFileButton button-text="Turkish" file-name="WEBSITE ASSET PACK/Website Asset pack TR.zip"
                                    container="files" color="#e5f6ff" text-color="#055699" />
                            </v-col>
                            <v-col cols="12" md="3">
                                <!-- <MarketingAssetsFileButton button-text="Hungarian" file-name="WEBSITE ASSET PACK/Hungarian.zip"
                                    container="files" color="#e5f6ff" text-color="#055699" /> -->
                            </v-col>
                        </v-row>
                    </v-container>
                </v-row>
                <v-row>
                    <v-container>
                        <p class="heading2">
                            <span class="heading1">1. Acquisition</span> - Encouraging partners to join RISE
                        </p>
                        <v-divider thickness="1" class="border-opacity-25 my-2" color="#055699"></v-divider>
                        <v-row class="mt-4">
                            <v-col cols="12" md="6">
                                <MarketingAssetsSection height="400px" heading="Distributor Introduction to RISE"
                                    text="This one-page overview is for you! Take a quick look at how the RISE Incentive Program can help boost your bottom line."
                                    :items="intrductionToRisePdfItems" />
                            </v-col>
                            <v-col cols="12" md="6">
                                <MarketingAssetsSection height="400px" heading="Distributor Introductory Guide"
                                    text="This presentation is for your own use. It introduces the RISE Incentive Program and gives you a clear, practical guide on how to encourage your partners to take part, helping you unlock more opportunities to boost your bottom line."
                                    :items="distributorPresentationItems" />
                            </v-col>
                        </v-row>
                        <v-row class="mt-4">
                            <v-col cols="12" md="6">
                                <MarketingAssetsSection heading="Partner Introduction to RISE"
                                    text="Need a simple way to explain the RISE Incentive Program? This one-page overview is perfect for sharing with Dell Technologies Authorized Tier partners."
                                    :items="intrductionToRiseVideoItems" />
                            </v-col>
                            <v-col cols="12" md="6">
                                <MarketingAssetsSection heading="Partner Introductory Guide"
                                    text="This presentation is designed to help you introduce the RISE Incentive Program to Dell Technologies Authorized Tier partners who haven’t yet joined. It outlines how to best position RISE in conversations with these partners and highlights why joining this market-leading program is a smart move for their business."
                                    :items="partnerPresentationPdfItems" />
                            </v-col>                            
                        </v-row>
                        <v-row class="mt-4">
                            <v-col cols="12" md="6">
                                <MarketingAssetsSection heading="RISE Program Banners"
                                    text="These RISE program banners can be shared with Dell Technologies Authorized Tier partners so they can learn about the RISE Incentive program and its many benefits."
                                    :items="riseProgramBannerItems" />
                            </v-col>
                            <v-col cols="12" md="6">
                            </v-col>
                        </v-row>                        
                    </v-container>
                </v-row>
                <v-row>
                    <v-container>
                        <p class="heading2">
                            <span class="heading1">2. Onboarding</span> - Guidance on the registration process
                        </p>
                        <v-divider thickness="1" class="border-opacity-25 my-2" color="#055699"></v-divider>
                        <v-row class="mt-4">                            
                            <v-col cols="12" md="6">
                                <MarketingAssetsSection heading="'Welcome to RISE' video"
                                    text="This video can be used to welcome Dell Technologies Authorized Tier partners to the RISE Incentive Program and provide an overview of the program structure, rules and its many benefits."
                                    :items="welcomeToRiseVideoItems" />
                            </v-col>
                            <v-col cols="12" md="6">
                               
                            </v-col>
                        </v-row>
                    </v-container>
                </v-row>
                <!-- <v-row>
                    <v-container>
                        <p class="heading2">
                            <span class="heading1">3. First Use</span> - Help with RISE reporting and tools
                        </p>
                        <v-divider thickness="1" class="border-opacity-25 my-2" color="#055699"></v-divider>
                        <v-row class="mt-4">
                            <v-col cols="12" md="6">
                                <MarketingAssetsSection heading="Distributor Performance and Redemption Guide"
                                    text="This guide is intended for your own use. It can be used to manage the new RISE redemption process and review Authorized Tier partners' RISE performance for rewards earned this quarter."
                                    :items="distributorPerformanceRedemptionGuideItems" />
                            </v-col>
                            <v-col cols="12" md="6">
                                <MarketingAssetsSection heading="'Partner RISE Reward Redemption Guide"
                                    text="This guide helps RISE partners to understand the new RISE reward redemption process for both e-vouchers and credit notes for rewards earned this quarter."
                                    :items="partnerRiseRewardRedemptionGuide" />
                            </v-col>
                        </v-row>
                    </v-container>
                </v-row> -->
                <v-row>
                    <v-container>
                        <p class="heading2">
                            <span class="heading1">3. Expansion</span> - Maximize RISE rewards
                        </p>
                        <v-divider thickness="1" class="border-opacity-25 my-2" color="#055699"></v-divider>
                        <v-row class="mt-4">
                            <v-col cols="12" md="6">
                                <MarketingAssetsSection heading="Precision Workstation Bonus Asset Packs"
                                    text="Use these asset packs to promote the Precision Workstation bonus. Offer available this quarter."
                                    :items="precisionWorkstationBonusAssetPackItems" />
                            </v-col>
                            <v-col cols="12" md="6">
                                <MarketingAssetsSection heading="Account Plays - 3x Latitude Bonus Asset Packs"
                                    text="Use these asset packs to promote 3x rewards on Latitude. Offer available this quarter."
                                    :items="accountPlays3xLatitudeBonusAssetPackItems" />
                            </v-col>
                        </v-row>
                        <v-row class="mt-4">
                            <v-col cols="12" md="6">
                                <MarketingAssetsSection heading="Account Plays - 2x OptiPlex Bonus Asset Packs"
                                    text="Use these asset packs to promote 2x rewards on OptiPlex. Offer available this quarter."
                                    :items="accountPlays2xOptiPlexBonusAssetPackItems" />
                            </v-col>
                            <v-col cols="12" md="6">
                                <MarketingAssetsSection heading="Storage and Server B2B Rewards Asset Packs"
                                    text="Use these asset packs to promote RISE rewards on Storage and Server B2B purchases. Available this quarter."
                                    :items="storageAndServerB2BRewardsAssetPackItems" />
                            </v-col>
                        </v-row>
                        <v-row class="mt-4">
                            <v-col cols="12" md="6">
                                <MarketingAssetsSection heading="Microsoft Windows Server ROK Rewards Asset Packs"
                                    text="Use these asset packs to promote RISE rewards on Microsoft Windows Server ROK purchases. Available this quarter."
                                    :items="microsoftWindowsServerRokRewardsAssetPackItems" />
                            </v-col>
                            <v-col cols="12" md="6">
                                <MarketingAssetsSection heading="Precision Workstation Bonus Banners"
                                    text="Use these banners to promote the Precision Workstation bonus. Offer available this quarter."
                                    :items="precisionWorkstationBonusBannerItems" />
                            </v-col>
                        </v-row>
                        <v-row class="mt-4">
                            <v-col cols="12" md="6">
                                <MarketingAssetsSection heading="First Purchase Bonus Banners"
                                    text="Use these banners to promote the First Purchase bonuses. Offer available this quarter."
                                    :items="firstPurchaseBonusBannerItems" />
                            </v-col>
                            <v-col cols="12" md="6">
                                <MarketingAssetsSection heading="Storage And Server B2B Banners"
                                    text="Use these banners to promote the Storage and Server bonuses. Offer available this quarter."
                                    :items="storageandServerB2BBannerItems" />
                            </v-col>
                        </v-row>
                    </v-container>
                </v-row>
            </v-col>
            <v-col cols="0" sm="2"></v-col>
        </v-row>
        <br>
    </div>
</template>
<script setup>
import { ref, onMounted, resolveComponent } from 'vue'
import LanguagePlaceholder from '@/components/LanguagePlaceholder.vue'
import MarketingAssetsFileButton from '@/components/MarketingAssetsFileButton.vue';
import MarketingAssetsSection from '@/components/MarketingAssetsSection.vue';
import { useSystemStore } from '@/stores/system'

const systemStore = useSystemStore()

onMounted(() => {

})


// ACQUISITIONS
const distributorPresentationItems = ref([
    { buttonText: 'Distributor Introductory Guide', fileName: 'Acquisitions/Distributor Presentation/RISE Distributor Introductory Guide.pdf', container: 'files' }
])


const intrductionToRisePdfItems = ref([
    { buttonText: 'Distributor Introduction to RISE', fileName: 'Acquisitions/Introduction to RISE PDF/Distributor Introduction to RISE.pdf', container: 'files' } 
])

const partnerPresentationPdfItems = ref([
    { buttonText: 'English', fileName: 'Acquisitions/Partner Presentation/RISE Partner Introductory Guide EN.pdf', container: 'files' },
    { buttonText: 'French', fileName: 'Acquisitions/Partner Presentation/RISE Partner Introductory Guide FR.pdf', container: 'files' },
    { buttonText: 'German', fileName: 'Acquisitions/Partner Presentation/RISE Partner Introductory Guide DE.pdf', container: 'files' },
    { buttonText: 'Italian', fileName: 'Acquisitions/Partner Presentation/RISE Partner Introductory Guide IT.pdf', container: 'files' },
    { buttonText: 'Polish', fileName: 'Acquisitions/Partner Presentation/RISE Partner Introductory Guide PL.pdf', container: 'files' },
    { buttonText: 'Spanish', fileName: 'Acquisitions/Partner Presentation/RISE Partner Introductory Guide ES.pdf', container: 'files' },
    { buttonText: 'Turkish', fileName: 'Acquisitions/Partner Presentation/RISE Partner Introductory Guide TR.pdf', container: 'files' },
    { buttonText: 'Romanian', fileName: 'Acquisitions/Partner Presentation/RISE Partner Introductory Guide RO.pdf', container: 'files' },
    { buttonText: 'Hungarian', fileName:  'Acquisitions/Partner Presentation/RISE Partner Introductory Guide HU.pdf', container: 'files' },
    { buttonText: 'Czech', fileName:   'Acquisitions/Partner Presentation/RISE Partner Introductory Guide CS.pdf', container: 'files' },

])

const intrductionToRiseVideoItems = ref([
    { buttonText: 'English', fileName: 'Acquisitions/Introduction to RISE video/Partner Introduction to RISE EN.pdf', container: 'files' },
    { buttonText: 'French', fileName: 'Acquisitions/Introduction to RISE video/Partner Introduction to RISE FR.pdf', container: 'files' },
    { buttonText: 'German', fileName: 'Acquisitions/Introduction to RISE video/Partner Introduction to RISE DE.pdf', container: 'files' },
    { buttonText: 'Italian', fileName: 'Acquisitions/Introduction to RISE video/Partner Introduction to RISE IT.pdf', container: 'files' },
    { buttonText: 'Polish', fileName: 'Acquisitions/Introduction to RISE video/Partner Introduction to RISE PL.pdf', container: 'files' },
    { buttonText: 'Spanish', fileName: 'Acquisitions/Introduction to RISE video/Partner Introduction to RISE ES.pdf', container: 'files' },
    { buttonText: 'Turkish', fileName: 'Acquisitions/Introduction to RISE video/Partner Introduction to RISE TR.pdf', container: 'files' },
    { buttonText: 'Romanian', fileName: 'Acquisitions/Introduction to RISE video/Partner Introduction to RISE RO.pdf', container: 'files' },
    { buttonText: 'Hungarian', fileName: 'Acquisitions/Introduction to RISE video/Partner Introduction to RISE HU.pdf', container: 'files' },
    { buttonText: 'Czech', fileName: 'Acquisitions/Introduction to RISE video/Partner Introduction to RISE CS.pdf', container: 'files' },
])

const riseProgramBannerItems = ref([
    { buttonText: 'English', fileName: 'Acquisitions/RISE Program Banners/RISE Program Banners EN.zip', container: 'files' },
    { buttonText: 'French', fileName: 'Acquisitions/RISE Program Banners/RISE Program Banners FR.zip', container: 'files' },
    { buttonText: 'German', fileName: 'Acquisitions/RISE Program Banners/RISE Program Banners DE.zip', container: 'files' },
    { buttonText: 'Italian', fileName: 'Acquisitions/RISE Program Banners/RISE Program Banners IT.zip', container: 'files' },
    { buttonText: 'Polish', fileName: 'Acquisitions/RISE Program Banners/RISE Program Banners PL.zip', container: 'files' },
    { buttonText: 'Spanish', fileName: 'Acquisitions/RISE Program Banners/RISE Program Banners ES.zip', container: 'files' },
    { buttonText: 'Turkish', fileName: 'Acquisitions/RISE Program Banners/RISE Program Banners TR.zip', container: 'files' },
    
    { buttonText: 'Romanian', fileName: 'Acquisitions/RISE Program Banners/RISE Program Banners RO.zip', container: 'files' },
    { buttonText: 'Hungarian', fileName: 'Acquisitions/RISE Program Banners/RISE Program Banners HU.zip', container: 'files' },
    { buttonText: 'Czech', fileName: 'Acquisitions/RISE Program Banners/RISE Program Banners CS.zip', container: 'files' },

])

// ONBOARDING

const welcomeToRiseVideoItems = ref([
    { buttonText: 'English', fileName: 'Onboarding/Welcome to RISE Video/Welcome to RISE FY25 EN.mp4', container: 'files' },
    // { buttonText: 'French', fileName: 'Onboarding/Welcome to RISE Video/Welcome to RISE FY25 FR.mp4', container: 'files' },
    // { buttonText: 'German', fileName: 'Onboarding/Welcome to RISE Video/Welcome to RISE FY25 DE.mp4', container: 'files' },
    // { buttonText: 'Italian', fileName: 'Onboarding/Welcome to RISE Video/Welcome to RISE FY25 IT.mp4', container: 'files' },
    // { buttonText: 'Polish', fileName: 'Onboarding/Welcome to RISE Video/Welcome to RISE FY25 PL.mp4', container: 'files' },
    // { buttonText: 'Spanish', fileName: 'Onboarding/Welcome to RISE Video/Welcome to RISE FY25 ES.mp4', container: 'files' },
    // { buttonText: 'Turkish', fileName: 'Onboarding/Welcome to RISE Video/Welcome to RISE FY25 TR.mp4', container: 'files' },

])

// FIRST USE

const distributorPerformanceRedemptionGuideItems = ref([
    { buttonText: 'Distributor Performance and Redemption Guide', fileName: 'First Use/Distributor Performance and Redemption Guide/Distributor Performance & Redemption Guide.pdf', container: 'files' }
])

const partnerRiseRewardRedemptionGuide = ref([
    { buttonText: 'English', fileName: 'First Use/Partner Reward Redemption Guide/RISE Reward Redemption Guide EN.pdf', container: 'files' },
    { buttonText: 'French', fileName: 'First Use/Partner Reward Redemption Guide/RISE Reward Redemption Guide FR.pdf', container: 'files' },
    { buttonText: 'German', fileName: 'First Use/Partner Reward Redemption Guide/RISE Reward Redemption Guide DE.pdf', container: 'files' },
    { buttonText: 'Italian', fileName: 'First Use/Partner Reward Redemption Guide/RISE Reward Redemption Guide IT.pdf', container: 'files' },
    { buttonText: 'Polish', fileName: 'First Use/Partner Reward Redemption Guide/RISE Reward Redemption Guide PL.pdf', container: 'files' },
    { buttonText: 'Spanish', fileName: 'First Use/Partner Reward Redemption Guide/RISE Reward Redemption Guide ES.pdf', container: 'files' },
    { buttonText: 'Turkish', fileName: 'First Use/Partner Reward Redemption Guide/RISE Reward Redemption Guide TR.pdf', container: 'files' },

])

// EXPANSION


const precisionWorkstationBonusAssetPackItems = ref([
    // { buttonText: 'Bulgarian', fileName: 'Expansion/Precision Workstation Bonus Asset Packs/Precision Workstation asset pack BG.zip', container: 'files' },
    { buttonText: 'Czech', fileName: 'Expansion/Precision Workstation Bonus Asset Packs/Precision Workstation asset pack CZ.zip', container: 'files' },
    // { buttonText: 'Dutch', fileName: 'Expansion/Precision Workstation Bonus Asset Packs/Precision Workstation asset pack NL.zip', container: 'files' },
    { buttonText: 'English', fileName: 'Expansion/Precision Workstation Bonus Asset Packs/Precision Workstation asset pack EN.zip', container: 'files' },
    { buttonText: 'French', fileName: 'Expansion/Precision Workstation Bonus Asset Packs/Precision Workstation asset pack FR.zip', container: 'files' },
    { buttonText: 'German', fileName: 'Expansion/Precision Workstation Bonus Asset Packs/Precision Workstation asset pack DE.zip', container: 'files' },
    // { buttonText: 'Greek', fileName: 'Expansion/Precision Workstation Bonus Asset Packs/Precision Workstation asset pack GR.zip', container: 'files' },
    { buttonText: 'Hungarian', fileName: 'Expansion/Precision Workstation Bonus Asset Packs/Precision Workstation asset pack HU.zip', container: 'files' },
    { buttonText: 'Italian', fileName: 'Expansion/Precision Workstation Bonus Asset Packs/Precision Workstation asset pack IT.zip', container: 'files' },
    { buttonText: 'Polish', fileName: 'Expansion/Precision Workstation Bonus Asset Packs/Precision Workstation asset pack PL.zip', container: 'files' },
    // { buttonText: 'Portugese', fileName: 'Expansion/Precision Workstation Bonus Asset Packs/Precision Workstation asset pack PT.zip', container: 'files' },
    { buttonText: 'Romanian', fileName: 'Expansion/Precision Workstation Bonus Asset Packs/Precision Workstation asset pack RO.zip', container: 'files' },
    { buttonText: 'Spanish', fileName: 'Expansion/Precision Workstation Bonus Asset Packs/Precision Workstation asset pack ES.zip', container: 'files' },
    { buttonText: 'Turkish', fileName: 'Expansion/Precision Workstation Bonus Asset Packs/Precision Workstation asset pack TR.zip', container: 'files' },

])

const accountPlays3xLatitudeBonusAssetPackItems = ref([
    { buttonText: 'English', fileName: 'Expansion/Account Plays - 3x Latitude Bonus Asset Packs/Latitude Asset Pack EN.zip', container: 'files' },
    { buttonText: 'French', fileName: 'Expansion/Account Plays - 3x Latitude Bonus Asset Packs/Latitude Asset Pack FR.zip', container: 'files' },
    { buttonText: 'German', fileName: 'Expansion/Account Plays - 3x Latitude Bonus Asset Packs/Latitude Asset Pack DE.zip', container: 'files' },
    { buttonText: 'Italian', fileName: 'Expansion/Account Plays - 3x Latitude Bonus Asset Packs/Latitude Asset Pack IT.zip', container: 'files' },
    { buttonText: 'Polish', fileName: 'Expansion/Account Plays - 3x Latitude Bonus Asset Packs/Latitude Asset Pack PL.zip', container: 'files' },
    { buttonText: 'Spanish', fileName: 'Expansion/Account Plays - 3x Latitude Bonus Asset Packs/Latitude Asset Pack ES.zip', container: 'files' },
    { buttonText: 'Turkish', fileName: 'Expansion/Account Plays - 3x Latitude Bonus Asset Packs/Latitude Asset Pack TR.zip', container: 'files' },

])


////////////////////////

const accountPlays2xOptiPlexBonusAssetPackItems = ref([
    { buttonText: 'English', fileName: 'Expansion/Account Plays - 2x OptiPlex Bonus Asset Packs/OptiPlex Asset Pack EN.zip', container: 'files' },
    { buttonText: 'French', fileName: 'Expansion/Account Plays - 2x OptiPlex Bonus Asset Packs/OptiPlex Asset Pack FR.zip', container: 'files' },
    { buttonText: 'German', fileName: 'Expansion/Account Plays - 2x OptiPlex Bonus Asset Packs/OptiPlex Asset Pack DE.zip', container: 'files' },
    { buttonText: 'Italian', fileName: 'Expansion/Account Plays - 2x OptiPlex Bonus Asset Packs/OptiPlex Asset Pack IT.zip', container: 'files' },
    { buttonText: 'Polish', fileName: 'Expansion/Account Plays - 2x OptiPlex Bonus Asset Packs/OptiPlex Asset Pack PL.zip', container: 'files' },
    { buttonText: 'Spanish', fileName: 'Expansion/Account Plays - 2x OptiPlex Bonus Asset Packs/OptiPlex Asset Pack ES.zip', container: 'files' },
    { buttonText: 'Turkish', fileName: 'Expansion/Account Plays - 2x OptiPlex Bonus Asset Packs/OptiPlex Asset Pack TR.zip', container: 'files' },

])

const storageAndServerB2BRewardsAssetPackItems = ref([
    { buttonText: 'English', fileName: 'Expansion/Storage and Server B2B Rewards Asset Packs/Storage and Server B2B-EN.zip', container: 'files' },
    { buttonText: 'French', fileName: 'Expansion/Storage and Server B2B Rewards Asset Packs/Storage and Server B2B-FR.zip', container: 'files' },
    { buttonText: 'German', fileName: 'Expansion/Storage and Server B2B Rewards Asset Packs/Storage and Server B2B-DE.zip', container: 'files' },
    { buttonText: 'Italian', fileName: 'Expansion/Storage and Server B2B Rewards Asset Packs/Storage and Server B2B-IT.zip', container: 'files' },
    { buttonText: 'Polish', fileName: 'Expansion/Storage and Server B2B Rewards Asset Packs/Storage and Server B2B-PL.zip', container: 'files' },
    { buttonText: 'Spanish', fileName: 'Expansion/Storage and Server B2B Rewards Asset Packs/Storage and Server B2B-ES.zip', container: 'files' },
    { buttonText: 'Turkish', fileName: 'Expansion/Storage and Server B2B Rewards Asset Packs/Storage and Server B2B-TR.zip', container: 'files' },

])

const microsoftWindowsServerRokRewardsAssetPackItems = ref([
    { buttonText: 'English', fileName: 'Expansion/Microsoft Windows Server ROK Rewards Asset Packs/ROK Asset Pack EN.zip', container: 'files' },
    { buttonText: 'French', fileName: 'Expansion/Microsoft Windows Server ROK Rewards Asset Packs/ROK Asset Pack FR.zip', container: 'files' },
    { buttonText: 'German', fileName: 'Expansion/Microsoft Windows Server ROK Rewards Asset Packs/ROK Asset Pack DE.zip', container: 'files' },
    { buttonText: 'Italian', fileName: 'Expansion/Microsoft Windows Server ROK Rewards Asset Packs/ROK Asset Pack IT.zip', container: 'files' },
    { buttonText: 'Polish', fileName: 'Expansion/Microsoft Windows Server ROK Rewards Asset Packs/ROK Asset Pack PL.zip', container: 'files' },
    { buttonText: 'Spanish', fileName: 'Expansion/Microsoft Windows Server ROK Rewards Asset Packs/ROK Asset Pack ES.zip', container: 'files' },
    { buttonText: 'Turkish', fileName: 'Expansion/Microsoft Windows Server ROK Rewards Asset Packs/ROK Asset Pack TR.zip', container: 'files' },

])

const precisionWorkstationBonusBannerItems = ref([
    { buttonText: 'English', fileName: 'Expansion/Precision Workstation Bonus Banners/Precision Bonus Banner EN.zip', container: 'files' },
    { buttonText: 'French', fileName: 'Expansion/Precision Workstation Bonus Banners/Precision Bonus Banner FR.zip', container: 'files' },
    { buttonText: 'German', fileName: 'Expansion/Precision Workstation Bonus Banners/Precision Bonus Banner DE.zip', container: 'files' },
    { buttonText: 'Italian', fileName: 'Expansion/Precision Workstation Bonus Banners/Precision Bonus Banner IT.zip', container: 'files' },
    { buttonText: 'Polish', fileName: 'Expansion/Precision Workstation Bonus Banners/Precision Bonus Banner PL.zip', container: 'files' },
    { buttonText: 'Spanish', fileName: 'Expansion/Precision Workstation Bonus Banners/Precision Bonus Banner ES.zip', container: 'files' },
    { buttonText: 'Turkish', fileName: 'Expansion/Precision Workstation Bonus Banners/Precision Bonus Banner TR.zip', container: 'files' },

])

const firstPurchaseBonusBannerItems = ref([
    { buttonText: 'English', fileName: 'Expansion/First Purchase Bonus Banners/First Purchase Bonus Banners EN.zip', container: 'files' },
    { buttonText: 'French', fileName: 'Expansion/First Purchase Bonus Banners/First Purchase Bonus Banners FR.zip', container: 'files' },
    { buttonText: 'German', fileName: 'Expansion/First Purchase Bonus Banners/First Purchase Bonus Banners DE.zip', container: 'files' },
    { buttonText: 'Italian', fileName: 'Expansion/First Purchase Bonus Banners/First Purchase Bonus Banners IT.zip', container: 'files' },
    { buttonText: 'Polish', fileName: 'Expansion/First Purchase Bonus Banners/First Purchase Bonus Banners PL.zip', container: 'files' },
    { buttonText: 'Spanish', fileName: 'Expansion/First Purchase Bonus Banners/First Purchase Bonus Banners ES.zip', container: 'files' },
    { buttonText: 'Turkish', fileName: 'Expansion/First Purchase Bonus Banners/First Purchase Bonus Banners TR.zip', container: 'files' },

])

const storageandServerB2BBannerItems = ref([
    { buttonText: 'English', fileName: 'Expansion/Storage and Server B2B Banners/Storage & Server B2B Banners EN.zip', container: 'files' },
    { buttonText: 'French', fileName: 'Expansion/Storage and Server B2B Banners/Storage & Server B2B Banners FR.zip', container: 'files' },
    { buttonText: 'German', fileName: 'Expansion/Storage and Server B2B Banners/Storage & Server B2B Banners DE.zip', container: 'files' },
    { buttonText: 'Italian', fileName: 'Expansion/Storage and Server B2B Banners/Storage & Server B2B Banners IT.zip', container: 'files' },
    { buttonText: 'Polish', fileName: 'Expansion/Storage and Server B2B Banners/Storage & Server B2B Banners PL.zip', container: 'files' },
    { buttonText: 'Spanish', fileName: 'Expansion/Storage and Server B2B Banners/Storage & Server B2B Banners ES.zip', container: 'files' },
    { buttonText: 'Turkish', fileName: 'Expansion/Storage and Server B2B Banners/Storage & Server B2B Banners TR.zip', container: 'files' },

])




</script>

<style scoped>
.heading1 {
    font-size: 24px;
    font-weight: 500;
}

.heading2 {
    font-size: 24px;
    font-weight: 300;
}
</style>